import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ezload_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  signup: (data) => api.post('/auth/signup', data).then(r => r.data),
  login: (data) => api.post('/auth/login', data).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
  sendOtp: (phone) => api.post('/auth/send-otp', { phone }).then(r => r.data),
  verifyOtp: (data) => api.post('/auth/verify-otp', data).then(r => r.data),
  sendEmailOtp: (email) => api.post('/auth/email/send-otp', { email }).then(r => r.data),
  verifyEmailOtp: (data) => api.post('/auth/email/verify-otp', data).then(r => r.data),
};

export const podApi = {
  upload: (loadId, data) => api.post(`/loads/${loadId}/pod`, data).then(r => r.data),
  get: (loadId) => api.get(`/loads/${loadId}/pod`).then(r => r.data),
};

export const loadsApi = {
  list: (params) => api.get('/loads', { params }).then(r => r.data),
  create: (data) => api.post('/loads', data).then(r => r.data),
  book: (id) => api.post(`/loads/${id}/book`).then(r => r.data),
};

export const trucksApi = {
  list: (params) => api.get('/trucks', { params }).then(r => r.data),
  create: (data) => api.post('/trucks', data).then(r => r.data),
};

export const paymentsApi = {
  create: (data) => api.post('/payments', data).then(r => r.data),
  transactions: () => api.get('/payments/transactions').then(r => r.data),
};

export const subscriptionApi = {
  get: () => api.get('/subscription').then(r => r.data),
  upgrade: (method) => api.post('/subscription/upgrade', { method }).then(r => r.data),
};

export const dashboardApi = {
  stats: () => api.get('/dashboard/stats').then(r => r.data),
};

export const trackingApi = {
  update: (data) => api.post('/tracking/update', data).then(r => r.data),
  get: (loadId) => api.get(`/tracking/${loadId}`).then(r => r.data),
};

export const tripsApi = {
  updateStatus: (data) => api.post('/trips/status', data).then(r => r.data),
  assigned: () => api.get('/trips/assigned').then(r => r.data),
  timeline: (loadId) => api.get(`/loads/${loadId}/timeline`).then(r => r.data),
};

export const driverApi = {
  earnings: () => api.get('/driver/earnings').then(r => r.data),
};

export const rateApi = {
  suggest: (params) => api.get('/rate-suggest', { params }).then(r => r.data),
};

export const routeApi = {
  info: (origin, destination) => api.get('/route-info', { params: { origin, destination } }).then(r => r.data),
  returnMatches: (loadId) => api.get(`/loads/${loadId}/return-matches`).then(r => r.data),
};

export const chatApi = {
  send: (loadId, data) => api.post(`/loads/${loadId}/messages`, { load_id: loadId, ...data }).then(r => r.data),
  list: (loadId, since) => api.get(`/loads/${loadId}/messages`, { params: since ? { since } : {} }).then(r => r.data),
  transcribe: (audio, language) => api.post('/chat/transcribe', { audio, language }, { timeout: 60000 }).then(r => r.data),
};

export const saveAuth = (token, user) => {
  localStorage.setItem('ezload_token', token);
  localStorage.setItem('ezload_user', JSON.stringify(user));
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem('ezload_user') || 'null'); } catch { return null; }
};

export const logout = () => {
  localStorage.removeItem('ezload_token');
  localStorage.removeItem('ezload_user');
};

export default api;
